export default ({ loading, sensor: { deleteHistoryJob } }) => {
  if (loading) return 'Loading...'

  return 'Delete Sensor history'
}
